import React, { useState } from 'react';
import { FiClock, FiInbox } from 'react-icons/fi';
import TarjetaPerfil, { Skeleton, Vacio } from './TarjetaPerfil';
import { ROL_LABELS, ESTADO_LABELS, DEPTO_LABELS } from '../../../../constants/usuarios';

const CAMPO_LABELS = {
  role: 'Rol',
  estado: 'Estado',
  dpto_tecnico: 'Departamento',
  contrasena: 'Contraseña',
};

const valorLabel = (campo, valor) => {
  if (valor === null || valor === undefined) return '—';
  if (campo === 'role') return ROL_LABELS[valor] || valor;
  if (campo === 'estado') return ESTADO_LABELS[valor] || valor;
  if (campo === 'dpto_tecnico') return DEPTO_LABELS[valor] || valor;
  return valor;
};

const VISIBLES_INICIALMENTE = 5;

/** Historial de cambios sensibles, plegado para que no estire la columna. */
const TarjetaAuditoria = ({ auditoria, cargando }) => {
  const [expandido, setExpandido] = useState(false);

  const visibles = expandido ? auditoria : auditoria.slice(0, VISIBLES_INICIALMENTE);
  const ocultos = auditoria.length - visibles.length;

  return (
    <TarjetaPerfil
      icono={FiClock}
      titulo="Historial de cambios"
      extra={!cargando && auditoria.length > 0 && (
        <span className="perfil-card-contador">{auditoria.length}</span>
      )}
    >
      {cargando ? (
        <Skeleton filas={3} />
      ) : auditoria.length === 0 ? (
        <Vacio icono={FiInbox}>Sin cambios registrados.</Vacio>
      ) : (
        <>
          <div className="mini-auditoria">
            {visibles.map((registro) => (
              <div key={registro.id} className="auditoria-item">
                <p>
                  <strong>{CAMPO_LABELS[registro.campo] || registro.campo}</strong>
                  {registro.campo === 'contrasena' ? (
                    ' reseteada'
                  ) : (
                    <>
                      : {valorLabel(registro.campo, registro.valor_anterior)}
                      {' → '}
                      <b>{valorLabel(registro.campo, registro.valor_nuevo)}</b>
                    </>
                  )}
                </p>
                <span className="auditoria-meta">
                  @{registro.realizado_por} · {new Date(registro.createdAt).toLocaleString('es-ES', {
                    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
                  })}
                </span>
              </div>
            ))}
          </div>

          {(ocultos > 0 || expandido) && (
            <button
              type="button"
              className="perfil-card-ver-mas"
              onClick={() => setExpandido((v) => !v)}
            >
              {expandido ? 'Ver menos' : `Ver ${ocultos} cambios más`}
            </button>
          )}
        </>
      )}
    </TarjetaPerfil>
  );
};

export default TarjetaAuditoria;
